import { Component } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  ChildStatus,
  InsiderRelationshipMappingFilter,
  InsiderType,
} from "src/api/models";
import { InsiderRelationshipMappingService } from "src/api/services";
import { RemapInsiderRelationshipComponent } from "../../modals/remap-insider-relationship/remap-insider-relationship.component";
import { UpdateInsiderRelationshipComponent } from "../../modals/update-insider-relationship/update-insider-relationship.component";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";

@Component({
  selector: "insider-relationship-app-processed",
  // imports: [],
  templateUrl: "./processed.component.html",
  styleUrl: "./processed.component.css",
  standalone: false,
})
export class InsiderRelationshipProcessedComponent {
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  processedInsiderRelationship: any[] = [];
  selectedSecurity: any[] = [];
  selectedDialogRow: any = null;
  // childInsider?: string;
  // Pagination for Security
  first = 0;
  rows = 10;
  searchByName?: string;
  parentInsider?: string;
  childInsider?: string;
  isLoading: boolean = false;
  ref!: DynamicDialogRef;
  selectedChildStatus?: ChildStatus | undefined;
  childStatus = ChildStatus.values();

  constructor(
    private _messageService: MessageService,
    public dialogService: DialogService,
    private _confirmationService: ConfirmationService,
    private _insiderRelationshipMappingService: InsiderRelationshipMappingService
  ) {}
  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getProcessedInsiderRelationship();
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
  onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getProcessedInsiderRelationship();
  }
  getProcessedInsiderRelationship() {
    const params: InsiderRelationshipMappingFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      childInsider: this.childInsider,
      parentInsider: this.parentInsider,
      childStatus: this.selectedChildStatus,
    };
    this.isLoading = true;
    this._insiderRelationshipMappingService
      .getProcessedRelationships(params)
      .subscribe({
        next: (value) => {
          this.processedInsiderRelationship = value ?? [];
        },
        error: (err) => {
          this.isLoading = false;
          this._messageService.add({
            summary: err.error.message,
            severity: "error",
          });
        },
        complete: () => {
          this.paginator.totalCount =
            this.processedInsiderRelationship?.[0]?.totalCount ?? 0;
          this.isLoading = false;
        },
      });
  }

  onRemapClick(insider?: any, event?: Event) {
    if (event) event.preventDefault();
    this.ref = this.dialogService.open(RemapInsiderRelationshipComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "80vw", height: "100vh", top: "0", left: "0" },
      contentStyle: { overflow: "auto", height: "calc(100vh - 5rem)" },
      baseZIndex: 10000,

      header: "Re-mapping",
      data: {
        insiders: insider,
      },
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getProcessedInsiderRelationship();
      }
    });
  }
  onUpdateClick(insider?: any, event?: Event) {
    if (event) event.preventDefault();
    this.ref = this.dialogService.open(UpdateInsiderRelationshipComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "80vw", height: "100vh", top: "0", left: "0" },
      contentStyle: { overflow: "auto", height: "calc(100vh - 5rem)" },
      baseZIndex: 10000,

      header: "Updating",
      data: {
        insiders: insider,
      },
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getProcessedInsiderRelationship();
      }
    });
  }
  onRemoveClick(insider: any) {
    this._confirmationService.confirm({
      key: "relation-confirm",
      message: "Are you sure you want to remove relation?",
      header: "Confirm Deletion",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const relationId = insider.insiderRelationshipId;

        this._insiderRelationshipMappingService
          .removeRelation(relationId)
          .subscribe({
            next: () => {
              this._messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Relation removed successfully",
              });
              this.getProcessedInsiderRelationship();
              this._confirmationService.close();
            },
            error: () => {
              this._messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Failed to remove relation",
              });
            },
          });
      },
    });
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(
    event: ClipboardEvent,
    field: "parentInsider" | "childInsider"
  ): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }
}
